"use client";

import { useSessionManager } from "@/lib/auth/sessionManager";

import { SessionWarning } from "./SessionWarning";

export const SessionManager = ({ children }: { children: React.ReactNode }) => {
  const { showWarning, remainingTime, extendSession, dismissWarning } = useSessionManager();

  return (
    <>
      {children}
      {showWarning && (
        <SessionWarning
          remainingTime={remainingTime}
          onExtend={extendSession}
          onDismiss={dismissWarning}
          warningType={"inactivity"}
        />
      )}
    </>
  );
};
